export const ExportSource =  {
    Tag: 'TAG',
    Segment: 'SEGMENT',
    Statistics: 'STATISTICS',
}

export const ExportDestination = {
    Tag: 'TAG',
    File: 'FILE',
    Trash: 'TRASH',
    Suppress: 'SUPPRESSED',
}

export const ExportFileFormats = {
    Xls: 'xls',
    Csv: 'csv',
    Pdf: 'pdf',
}

export const ExportStatus = {
    Preparing: 'PREPARING',
    Processing: 'PROCESSING',
    Stopping: 'STOPPING',
    Stopped: 'STOPPED',
    Failed: 'FAILED',
    Finished: 'FINISHED',
}
